const NOMES_MES = [
    "JANEIRO", "FEVEREIRO", "MARCO", "ABRIL", "MAIO", "JUNHO",
    "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO",
];

export function mesAtual() {
    return NOMES_MES[new Date().getMonth()];
}

/** verde = positivo e confortável, amarelo = positivo mas abaixo de 20% do orçado, vermelho = negativo. */
export function statusSaldo(saldo, orcado) {
    const valor = Number(saldo ?? 0);
    if (valor < 0) return "vermelho";
    const base = Number(orcado ?? 0);
    if (base > 0 && valor / base < 0.2) return "amarelo";
    return "verde";
}

const CLASSES = {
    verde: "text-success",
    amarelo: "text-amber-600",
    vermelho: "text-destructive",
};

export function classeSaldo(saldo, orcado) {
    return CLASSES[statusSaldo(saldo, orcado)];
}

/** Compara soma vs total tolerando erro de ponto flutuante — arredonda ambos para centavos antes de comparar. */
export function somaBateComTotal(soma, total) {
    if (total == null || Number(total) <= 0) return false;
    return Math.round(Number(soma) * 100) === Math.round(Number(total) * 100);
}

/** Arredonda pra centavos — usado tanto ao importar rateio por percentual quanto ao recalcular por mudança de valor total. */
export function arredondarMoeda(valor) {
    return Math.round((Number(valor) || 0) * 100) / 100;
}

/**
 * Normaliza itens de rateio (tanto o formato já resolvido pelo backend — RateioOrcamentarioItemDTO,
 * campo de valor "valorRateado" — quanto o formato ainda em edição no RateioOrcamentarioEditor,
 * campo "valor") no shape simples que a tabela de rateio embutida no PDF assinado espera.
 * `campoValor` deixa explícito qual chave ler em cada chamada, já que os dois formatos divergem
 * só nesse campo. Conta e Centro de Custo entram só com o código (sem a descrição) — a tabela do
 * PDF é compacta, não tem espaço pra descrição.
 */
export function mapearRateioParaPdf(itens = [], campoValor = "valorRateado") {
    return itens.map(item => ({
        numeroNotaFiscal: item.numeroNotaFiscal || "",
        contaLabel: item.contaReduzido || item.contaFinanceiraCodigo || "",
        filial: item.filialNome || "",
        centroCusto: item.centroCustoCodigo || "",
        valor: Number(item[campoValor]) || 0,
    }));
}
